import { useEffect, useState } from "react";
/**
 * Debounce function used to update the Order Flow store
 *
 * @param store
 * @param delay
 * @returns
 */
export const useCalculationDebounce = (store, delay) => {
    const [debouncedStore, setDebouncedStore] = useState(store);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedStore(store);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [store, delay]);
    return debouncedStore;
};
